export default __webpack_public_path__ + "static/media/LSP4.d05e12df.png";